import BaseScreen from './_base';

export default function SearchDetailScreen() {
  return <BaseScreen title="Search Detail" description="Search results table." />;
}
